import { useMemo } from 'react';
import { useLocalizeOptionsQuery } from '../../../api/useLocalizeOptionsQuery';
import { Language, LanguageCode } from '../../../../CommonSelectors/CommonArea.types';

export interface LanguagePreferenceData {
  currentLanguage?: string;
  languageOptions: {
    code: LanguageCode;
    text?: string;
    value: Language;
    selected: boolean;
  }[];
}

export const useLanguagePreference = (clientId: string) => {
  const queryInfo = useLocalizeOptionsQuery(clientId);

  const currentLanguage = Localize.getLanguage();

  const data: LanguagePreferenceData | null = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const availableLanguages: { code: LanguageCode; name: string }[] = [];

    Localize.getAvailableLanguages((err, languages) => {
      if (err) {
        throw err;
      }

      languages.forEach(language => availableLanguages.push(language));
    });

    return {
      currentLanguage: availableLanguages.find(({ code }) => code === currentLanguage)?.name,
      languageOptions: queryInfo.data.map(({ label, value }) => ({
        code: label,
        text: availableLanguages.find(({ code }) => code === label)?.name,
        value,
        selected: label === currentLanguage,
      })),
    };
  }, [queryInfo, currentLanguage]);

  return {
    ...queryInfo,
    data,
  };
};
